import { render, staticRenderFns } from "./ModalConfirmacao.vue?vue&type=template&id=86ca9930&scoped=true&"
import script from "./ModalConfirmacao.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmacao.vue?vue&type=style&index=0&id=86ca9930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ca9930",
  null
  
)

export default component.exports